import PhotoGroupPhotoViewerActions from './PhotoGroupPhotoViewerActions';

export default PhotoGroupPhotoViewerActions;
